// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"245":"20848379","432":"f2900f70"}[chunkId] + ".css";
};